import * as tokens from '../../../../../tokens/color.dark.generated.js';
export const systemColorDark = {
    color: {
        canvas: {
            100: tokens.SYS_COLOR_CANVAS_100_DARK,
            200: tokens.SYS_COLOR_CANVAS_200_DARK
        },
        surface: {
            loadingLayer: {
                fill: {
                    100: tokens.SYS_COLOR_SURFACE_LOADING_LAYER_FILL_100_DARK,
                    200: tokens.SYS_COLOR_SURFACE_LOADING_LAYER_FILL_200_DARK
                }
            },
            interactive: {
                formControls: {
                    default: {
                        100: {
                            fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_100_FILL_DARK,
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_100_STROKE_DARK
                        },
                        200: {
                            fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_200_FILL_DARK,
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_200_STROKE_DARK
                        },
                        300: {
                            fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_300_FILL_DARK,
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_300_STROKE_DARK
                        }
                    },
                    disabled: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_DISABLED_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_DISABLED_STROKE_DARK
                    },
                    selected: {
                        100: {
                            fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_SELECTED_100_FILL_DARK,
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_SELECTED_100_STROKE_DARK
                        },
                        200: {
                            fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_SELECTED_200_FILL_DARK,
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_SELECTED_200_STROKE_DARK
                        },
                        300: {
                            fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_SELECTED_300_FILL_DARK,
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_SELECTED_300_STROKE_DARK
                        },
                        disabled: {
                            fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_SELECTED_DISABLED_FILL_DARK,
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_SELECTED_DISABLED_STROKE_DARK
                        }
                    }
                },
                formFields: {
                    100: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORMFIELDS_100_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORMFIELDS_100_STROKE_DARK
                    },
                    200: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORMFIELDS_200_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORMFIELDS_200_STROKE_DARK
                    },
                    300: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORMFIELDS_300_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORMFIELDS_300_STROKE_DARK
                    }
                },
                navigation: {
                    100: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_NAVIGATION_100_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_NAVIGATION_100_STROKE_DARK
                    },
                    200: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_NAVIGATION_200_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_NAVIGATION_200_STROKE_DARK
                    },
                    300: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_NAVIGATION_300_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_NAVIGATION_300_STROKE_DARK
                    }
                },
                card: {
                    default: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_STROKE_DARK
                    },
                    active: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_CARD_ACTIVE_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_CARD_ACTIVE_STROKE_DARK
                    }
                },
                primary: {
                    100: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_STROKE_DARK
                    },
                    200: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_200_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_200_STROKE_DARK
                    },
                    300: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_300_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_300_STROKE_DARK
                    }
                },
                secondary: {
                    100: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_SECONDARY_100_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_SECONDARY_100_STROKE_DARK
                    },
                    200: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_SECONDARY_200_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_SECONDARY_200_STROKE_DARK
                    },
                    300: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_SECONDARY_300_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_SECONDARY_300_STROKE_DARK
                    }
                },
                tertiary: {
                    100: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TERTIARY_100_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TERTIARY_100_STROKE_DARK
                    },
                    200: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TERTIARY_200_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TERTIARY_200_STROKE_DARK
                    },
                    300: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TERTIARY_300_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TERTIARY_300_STROKE_DARK
                    }
                },
                quaternary: {
                    100: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_QUATERNARY_100_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_QUATERNARY_100_STROKE_DARK
                    },
                    200: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_QUATERNARY_200_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_QUATERNARY_200_STROKE_DARK
                    },
                    300: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_QUATERNARY_300_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_QUATERNARY_300_STROKE_DARK
                    },
                    400: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_QUATERNARY_400_FILL_DARK,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_QUATERNARY_400_STROKE_DARK
                    }
                },
                tile: {
                    default: {
                        disabled: {
                            fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_DEFAULT_DISABLED_FILL_DARK,
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_DEFAULT_DISABLED_STROKE_DARK
                        },
                        100: {
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_DEFAULT_100_STROKE_DARK,
                            fill: {
                                stops: {
                                    0: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_DEFAULT_100_FILL_STOPS_0_DARK,
                                    100: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_DEFAULT_100_FILL_STOPS_100_DARK
                                }
                            }
                        },
                        200: {
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_DEFAULT_200_STROKE_DARK,
                            fill: {
                                stops: {
                                    0: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_DEFAULT_200_FILL_STOPS_0_DARK,
                                    100: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_DEFAULT_200_FILL_STOPS_100_DARK
                                }
                            }
                        }
                    },
                    100: {
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_100_STROKE_DARK,
                        fill: {
                            stops: {
                                0: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_100_FILL_STOPS_0_DARK,
                                100: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_100_FILL_STOPS_100_DARK
                            }
                        }
                    },
                    200: {
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_200_STROKE_DARK,
                        fill: {
                            stops: {
                                0: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_200_FILL_STOPS_0_DARK,
                                100: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_200_FILL_STOPS_100_DARK
                            }
                        }
                    },
                    selected: {
                        disabled: {
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_SELECTED_DISABLED_STROKE_DARK,
                            fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_SELECTED_DISABLED_FILL_DARK
                        },
                        100: {
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_SELECTED_100_STROKE_DARK,
                            fill: {
                                stops: {
                                    0: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_SELECTED_100_FILL_STOPS_0_DARK,
                                    100: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_SELECTED_100_FILL_STOPS_100_DARK
                                }
                            }
                        },
                        200: {
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_SELECTED_200_STROKE_DARK,
                            fill: {
                                stops: {
                                    0: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_SELECTED_200_FILL_STOPS_0_DARK,
                                    100: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_SELECTED_200_FILL_STOPS_100_DARK
                                }
                            }
                        }
                    }
                }
            },
            neutral: {
                100: tokens.SYS_COLOR_SURFACE_NEUTRAL_100_DARK,
                200: tokens.SYS_COLOR_SURFACE_NEUTRAL_200_DARK,
                300: tokens.SYS_COLOR_SURFACE_NEUTRAL_300_DARK,
                400: tokens.SYS_COLOR_SURFACE_NEUTRAL_400_DARK,
                500: tokens.SYS_COLOR_SURFACE_NEUTRAL_500_DARK,
                600: tokens.SYS_COLOR_SURFACE_NEUTRAL_600_DARK,
                700: tokens.SYS_COLOR_SURFACE_NEUTRAL_700_DARK,
                800: tokens.SYS_COLOR_SURFACE_NEUTRAL_800_DARK,
                transparent: tokens.SYS_COLOR_SURFACE_NEUTRAL_TRANSPARENT_DARK
            },
            signal: {
                positive: {
                    100: tokens.SYS_COLOR_SURFACE_SIGNAL_POSITIVE_100_DARK,
                    200: tokens.SYS_COLOR_SURFACE_SIGNAL_POSITIVE_200_DARK
                },
                negative: tokens.SYS_COLOR_SURFACE_SIGNAL_NEGATIVE_DARK,
                pending: tokens.SYS_COLOR_SURFACE_SIGNAL_PENDING_DARK,
                focus: tokens.SYS_COLOR_SURFACE_SIGNAL_FOCUS_DARK
            },
            disabled: {
                stroke: {
                    100: tokens.SYS_COLOR_SURFACE_DISABLED_STROKE_100_DARK,
                    transparent: tokens.SYS_COLOR_SURFACE_DISABLED_STROKE_TRANSPARENT_DARK
                },
                fill: {
                    100: tokens.SYS_COLOR_SURFACE_DISABLED_FILL_100_DARK,
                    200: tokens.SYS_COLOR_SURFACE_DISABLED_FILL_200_DARK,
                    transparent: tokens.SYS_COLOR_SURFACE_DISABLED_FILL_TRANSPARENT_DARK
                }
            },
            scrim: {
                default: tokens.SYS_COLOR_SURFACE_SCRIM_DEFAULT_DARK
            },
            highlight: {
                primary: tokens.SYS_COLOR_SURFACE_HIGHLIGHT_PRIMARY_DARK,
                secondary: tokens.SYS_COLOR_SURFACE_HIGHLIGHT_SECONDARY_DARK
            },
            encourage: {
                fill: tokens.SYS_COLOR_SURFACE_ENCOURAGE_FILL_DARK,
                stroke: tokens.SYS_COLOR_SURFACE_ENCOURAGE_STROKE_DARK
            }
        },
        elevation: {
            level1: {
                fill: {
                    stops: {
                        0: tokens.SYS_COLOR_ELEVATION_LEVEL1_FILL_STOPS_0_DARK,
                        100: tokens.SYS_COLOR_ELEVATION_LEVEL1_FILL_STOPS_100_DARK
                    }
                },
                stroke: tokens.SYS_COLOR_ELEVATION_LEVEL1_STROKE_DARK
            },
            level2: {
                stroke: tokens.SYS_COLOR_ELEVATION_LEVEL2_STROKE_DARK,
                shadowColor: tokens.SYS_COLOR_ELEVATION_LEVEL2_SHADOW_COLOR_DARK,
                fill: {
                    stops: {
                        0: tokens.SYS_COLOR_ELEVATION_LEVEL2_FILL_STOPS_0_DARK,
                        100: tokens.SYS_COLOR_ELEVATION_LEVEL2_FILL_STOPS_100_DARK
                    }
                }
            },
            level3: {
                fill: {
                    stops: {
                        0: tokens.SYS_COLOR_ELEVATION_LEVEL3_FILL_STOPS_0_DARK,
                        100: tokens.SYS_COLOR_ELEVATION_LEVEL3_FILL_STOPS_100_DARK
                    }
                },
                stroke: tokens.SYS_COLOR_ELEVATION_LEVEL3_STROKE_DARK,
                shadowColor: tokens.SYS_COLOR_ELEVATION_LEVEL3_SHADOW_COLOR_DARK
            }
        },
        text: {
            copy: {
                default: tokens.SYS_COLOR_TEXT_COPY_DEFAULT_DARK
            },
            headline: {
                default: tokens.SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK
            },
            display: {
                default: tokens.SYS_COLOR_TEXT_DISPLAY_DEFAULT_DARK
            },
            caption: {
                default: tokens.SYS_COLOR_TEXT_CAPTION_DEFAULT_DARK
            }
        },
        static: {
            100: {
                opa20: tokens.SYS_COLOR_STATIC_100_OPA20_DARK,
                solid: tokens.SYS_COLOR_STATIC_100_SOLID_DARK
            },
            900: {
                opa20: tokens.SYS_COLOR_STATIC_900_OPA20_DARK,
                solid: tokens.SYS_COLOR_STATIC_900_SOLID_DARK
            }
        },
        foreground: {
            signal: {
                positive: {
                    100: tokens.SYS_COLOR_FOREGROUND_SIGNAL_POSITIVE_100_DARK,
                    200: tokens.SYS_COLOR_FOREGROUND_SIGNAL_POSITIVE_200_DARK
                },
                negative: tokens.SYS_COLOR_FOREGROUND_SIGNAL_NEGATIVE_DARK,
                pending: tokens.SYS_COLOR_FOREGROUND_SIGNAL_PENDING_DARK
            },
            neutral: {
                100: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_100_DARK,
                200: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_200_DARK,
                300: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_300_DARK,
                400: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_400_DARK,
                500: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_500_DARK,
                600: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_600_DARK,
                700: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_700_DARK,
                800: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_800_DARK
            },
            onEncourage: {
                default: tokens.SYS_COLOR_FOREGROUND_ON_ENCOURAGE_DEFAULT_DARK
            }
        }
    },
    gradient: {
        elevation: {
            level1: { fill: tokens.SYS_GRADIENT_ELEVATION_LEVEL1_FILL_DARK },
            level2: { fill: tokens.SYS_GRADIENT_ELEVATION_LEVEL2_FILL_DARK },
            level3: { fill: tokens.SYS_GRADIENT_ELEVATION_LEVEL3_FILL_DARK }
        }
    }
};
//# sourceMappingURL=color.dark.js.map